import {FETCH_COMPANY, UPDATE_COMPANY} from "./types";
import {simpleRequest} from "../newForms2/simpleRequest";

export function fetchCompanyFromAPI(id) {
  return async function (dispatch) {
    const response = await simpleRequest({url: `companies/${id}`, method: "get"});
    const company = response.data && response.data.company;
    console.log({companyNewLoad: company});
    return dispatch(getCompany(company));
  };
}
function getCompany(company) {
  return {
    type: FETCH_COMPANY,
    company
  };
}
export function updateCompanyOnAPI(id, data) {
  return async function (dispatch) {
    const response = await simpleRequest({url: `companies/${id}`, method: "patch", data});
    const company = response.data && response.data.company;
    return dispatch(updateCompany(company));
  };
}
function updateCompany(company) {
  return {
    type: UPDATE_COMPANY,
    company
  };
}
